import "./style.css";
import { t } from "../../services/formatters";
import { Consenso } from "../Consenso";
import { useSession } from "../../hooks/useSession";

export const Informative = ({}) => {
    const { read, update } = useSession();

    const scrollToNextElement = (destinationIdx = null) => {
        // default to "fissa" button
        let destinationNode = document.querySelector(".btn-txt-container");
        if (null != destinationIdx) {
            destinationNode = document.querySelectorAll(".tos-item-component__header input[type=radio]")[destinationIdx];
        }
        destinationNode.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
    };

    return (
        <div className="section tos-list-component">
            <h3>{t("we_need_your_consent_1")}</h3>
            <br />
            <p className="">
            Il sottoscritto, cliccando sul tasto CONFERMA APPUNTAMENTO, dichiara di aver preso visione dell'Informativa resa da Compass e da Banca MPS <span class='color-text-primary'><a target='_blank' href={read("prodotto") == "minicredito" ? "https://www.compass.it/share/pdfsni/COM540.PDF" :  'https://www.compass.it/share/pdfsni/INFORMATIVA-CONGIUNTA-COMPASS-BANCA-MPS.PDF'} ><u>ai sensi degli art. 13 e 14 del Regolamento UE 2016/679</u></a></span> e della normativa nazionale vigente in materia di protezione dei dati personali, nella loro rispettiva qualità di Titolari autonomi come descritto nella suddetta informativa.
            </p>

            <div className={`section input-box-component hidden`}>
                <p className="crea-appto-error tos-list-component-appto-error text-center hidden">Devi rispondere a tutti i punti sotto elencati.</p>
                {/* <Consenso
          defaultValue={read("privacyExtcommoffer")}
          onChange={(value) => {
            update("privacyExtcommoffer", value);
            scrollToNextElement(2);
          }}
          name="privacyExtcommoffer"
          text={t("tos_1")}
        />
        <hr />
        <Consenso
          defaultValue={read("privacyOtherservice")}
          onChange={(value) => {
            update("privacyOtherservice", value);
            scrollToNextElement(4);
          }}
          name="privacyOtherservice"
          text={t("tos_2")}
        />
        <hr />
        <Consenso
          defaultValue={read("privacyProfilazione")}
          onChange={(value) => {
            update("privacyProfilazione", value);
            scrollToNextElement(6);
          }}
          name="privacyProfilazione"
          text={t("tos_3")}
        />
        <hr /> */}

                <p className="crea-appto-error tos-list-component-sic-appto-error text-center hidden">
                    <br />È obbligatorio il consenso.
                </p>
                <Consenso
                    defaultValue={true}
                    onChange={(value) => {
                        update("privacyInterncommoffer", value);
                        scrollToNextElement();
                    }}
                    name="privacyInterncommoffer"
                    text={t("tos_1")}
                    classList="tos-sic"
                />
            </div>
        </div>
    );
};
